import React, { useEffect, useState } from "react";
import "../movieList/movieList.css";
import { useParams } from "react-router-dom";
import Cards from "../card/card";

const Genre = () => {
    const [movieList, setMovieList] = useState([]);
    const [genres, setGenres] = useState([]);
    const [selectedGenre, setSelectedGenre] = useState("");
    const [page, setPage] = useState(1); // Track current page
    const [totalPages, setTotalPages] = useState(1); // Track total pages
    const { genre } = useParams();

    useEffect(() => {
        fetchGenres();
    }, []); // Fetch genres when component mounts

    useEffect(() => {
        if (genre) {
            setSelectedGenre(genre);
            setPage(1); // Reset page when genre changes
            getData(genre, 1);
        }
    }, [genre]); // Trigger getData whenever the genre changes

    const fetchGenres = () => {
        fetch(`https://api.themoviedb.org/3/genre/movie/list?api_key=4e44d9029b1270a757cddc766a1bcb63&language=en-US`)
            .then(res => res.json())
            .then(data => setGenres(data.genres || []))
            .catch(error => console.error("Error fetching genres:", error));
    }

    const getData = (
        selectedGenre, page) => {
        fetch(`https://api.themoviedb.org/3/discover/movie?api_key=4e44d9029b1270a757cddc766a1bcb63&language=en-US&with_genres=${selectedGenre}&page=${page}`)
            .then(res => res.json())
            .then(data => {
                setMovieList(prevMovies => [...prevMovies, ...data.results]); // Append new data to existing movie list
                setTotalPages(data.total_pages); // Update total pages
            })
            .catch(error => console.error("Error fetching movie data:", error));
    }

    const handleGenreChange = (event) => {
        const selectedGenre = event.target.value;
        setSelectedGenre(selectedGenre);
        setPage(1); // Reset page when genre changes
        setMovieList([]); // Clear movie list when genre changes
        getData(selectedGenre, 1);
    };

    const handleLoadMore = () => {
        const nextPage = page + 1;
        if (nextPage <= totalPages) {
            setPage(nextPage);
            getData(selectedGenre, nextPage);
        }
    };

    return (
        <div className="movie__list">
            <h2 className="list__title">{selectedGenre.toUpperCase()}</h2>
            <div className="genre-dropdown text-center mb-4">
                <select className="form-select" value={selectedGenre} onChange={handleGenreChange} style={{ margin:"auto",width: "200px", borderRadius: "8px", padding: "8px" }}>
                    <option value="">Select Genre</option>
                    {genres.map((genre) => (
                        <option key={genre.id} value={genre.id} data-id={genre.id}>
                            {genre.name}
                        </option>
                    ))}
                </select>
            </div>
            <div className="list__cards">
                {movieList.map((movie, index) => (
                    <Cards key={movie.id} movie={movie} index={index} />
                ))}
            </div>
            {page < totalPages && (
                <div className="text-center">
                    <button className="btn btn-primary" style={{backgroundColor:"white",color:"black"}} onClick={handleLoadMore}>Load More</button>
                </div>
            )}
        </div>
    )
}

export default Genre;
